import { Check } from 'lucide-react'

import { ConnectTerminalTelematics } from '@/components/ConnectTerminalTelematics'

export const STEP_ELD_QUESTION = "Last step! Let's connect your driving logs."

/** Step 3: the roster the vault chases files for comes off the ELD. */
export function StepEld({ connected, onConnected }: { connected: boolean; onConnected: () => void }) {
  return (
    <div className="flex flex-col items-start gap-4 pb-6">
      <p className="text-md text-ink-600 max-w-2xl leading-relaxed">
        This is the single most important thing to enable
        {/* Desktop only — at phone width the line already wraps on its own. */}
        <br className="max-sm:hidden" /> Cai to help you proactively avoid violations and fines.
      </p>
      {connected ? (
        <p className="text-ink-600 flex items-center gap-2 text-sm">
          <Check className="text-accent-green size-4 shrink-0" strokeWidth={3} />
          ELD connected. Your roster fills in as it syncs.
        </p>
      ) : (
        <ConnectTerminalTelematics
          type="POST_BIND"
          handleSuccess={onConnected}
          buttonProps={{
            children: 'Connect your ELD',
            className: 'border-ink-900 bg-ink-900 text-ink-50 hover:border-ink-700 hover:bg-ink-700',
          }}
        />
      )}
    </div>
  )
}
